import { render, staticRenderFns } from "./CountryDetail.vue?vue&type=template&id=346b85f5&scoped=true&"
import script from "./CountryDetail.vue?vue&type=script&lang=js&"
export * from "./CountryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346b85f5",
  null
  
)

export default component.exports